import { render, staticRenderFns } from "./BonnLevel.vue?vue&type=template&id=44df2630&scoped=true&"
import script from "./BonnLevel.vue?vue&type=script&lang=js&"
export * from "./BonnLevel.vue?vue&type=script&lang=js&"
import style0 from "./BonnLevel.vue?vue&type=style&index=0&id=44df2630&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df2630",
  null
  
)

export default component.exports